import {
  createFontStyle,
  createFontSizeStyle,
  createFontWeightStyle,
  createLineHeight,
  createFontFamily,
  createLetterSpacing,
  createTextTransform,
} from './utils/typography';

const createFontFamilyIBM = () => createFontFamily('IBM Plex Sans', true);
const createFontFamilyRoboto = () => createFontFamily('Roboto Condensed', true);

const font = {
  mainFont: createFontStyle(createFontFamilyIBM()),
  robotoFont: createFontStyle(createFontFamilyRoboto()),
};
const typography = {
  bodyLargeHighlight: createFontStyle(
    createFontFamilyIBM(),
    createFontSizeStyle(18),
    createFontWeightStyle('700'),
    createLineHeight('21px'),
  ),
  largeText: createFontStyle(
    createFontFamilyIBM(),
    createFontSizeStyle(18),
    createLineHeight('21px'),
  ),
  nomalText: createFontStyle(
    createFontFamilyIBM(),
    createFontSizeStyle(14),
    createLineHeight('18px'),
  ),
  smallText: createFontStyle(
    createFontFamilyIBM(),
    createFontSizeStyle(12),
    createLineHeight('16px'),
  ),
  link: createFontStyle(
    createFontFamilyIBM(),
    createFontSizeStyle(14),
    createFontWeightStyle('700'),
    createLineHeight('18px'),
  ),
  field: createFontStyle(
    createFontFamilyIBM(),
    createFontSizeStyle(16),
    createFontWeightStyle('400'),
    createLineHeight('24px'),
  ),
  bodyHighlight: createFontStyle(
    createFontFamilyIBM(),
    createFontSizeStyle(21),
    createFontWeightStyle('700'),
    createLineHeight('21px'),
  ),
  error: createFontStyle(
    createFontFamilyIBM(),
    createFontSizeStyle(12),
    createFontWeightStyle('400'),
    createLineHeight('24px'),
  ),
  headline: createFontStyle(
    createFontFamilyIBM(),
    createFontSizeStyle(40),
    createFontWeightStyle('500'),
    createLineHeight('52px'),
  ),
  title: createFontStyle(
    createFontFamilyIBM(),
    createFontSizeStyle(32),
    createFontWeightStyle('500'),
    createLineHeight('42px'),
  ),
  subtitle: createFontStyle(
    createFontFamilyIBM(),
    createFontSizeStyle(24),
    createFontWeightStyle('500'),
    createLineHeight('31px'),
  ),
  button: createFontStyle(
    createFontFamilyIBM(),
    createFontSizeStyle(14),
    createLineHeight('18px'),
    createTextTransform('uppercase'),
  ),
  body: createFontStyle(createFontFamilyIBM(), createFontSizeStyle(12), createLineHeight('18px')),
  body1: createFontStyle(createFontFamilyIBM(), createFontSizeStyle(14), createLineHeight('16px')),
  body2: createFontStyle(createFontFamilyIBM(), createFontSizeStyle(16), createLineHeight('21px')),
  caption: createFontStyle(
    createFontFamilyIBM(),
    createFontSizeStyle(10),
    createLineHeight('13px'),
    createLetterSpacing('0.03em'),
  ),
  bodyLargeHighlightApaleoCharge: createFontStyle(
    createFontFamilyIBM(),
    createFontSizeStyle(16),
    createFontWeightStyle('700'),
    createLineHeight('21px'),
  ),
  bodyLargeHighlightApaleoChargeTab: createFontStyle(
    createFontFamilyIBM(),
    createFontSizeStyle(14),
    createFontWeightStyle('700'),
    createLineHeight('21px'),
  ),
  paymentTableCellValue: createFontStyle(
    createFontFamilyIBM(),
    createFontSizeStyle(14),
    createFontWeightStyle('400'),
    createLineHeight('18px'),
  ),
};

export default typography;
export { font };
